import { render, staticRenderFns } from "./PostCategories.vue?vue&type=template&id=3fcc1ec2&scoped=true&"
import script from "./PostCategories.vue?vue&type=script&lang=js&"
export * from "./PostCategories.vue?vue&type=script&lang=js&"
import style0 from "@@/core/pages/post/PostCategories/PostCategoriesStyle.css?vue&type=style&index=0&id=3fcc1ec2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcc1ec2",
  null
  
)

export default component.exports